// Contractor-facing Settlement status taxonomy (2026-06).
// Independent-contractor terminology only — "Settlement", never payroll/wages.

export const SETTLEMENT_STATUS = {
  pending_approval: {
    key: 'pending_approval',
    label: 'Pending Approval',
    tileLabel: 'Pending Approval Settlement',
    badge: 'bg-amber-50 text-amber-700 border border-amber-200',
    tile: 'text-amber-600',
    dot: 'bg-amber-500',
    explanation:
      'Your completed shift has been received. Your hours and settlement are currently being reviewed. No action is needed from you.',
  },
  approved: {
    key: 'approved',
    label: 'Approved for Settlement',
    tileLabel: 'Approved / Upcoming Settlement',
    badge: 'bg-blue-50 text-blue-700 border border-blue-200',
    tile: 'text-blue-600',
    dot: 'bg-blue-500',
    explanation:
      'Your hours and settlement have been approved. Your settlement is scheduled according to the payment terms for this gig.',
  },
  payment_processing: {
    key: 'payment_processing',
    label: 'Settlement Processing',
    tileLabel: 'Settlement Processing',
    badge: 'bg-indigo-50 text-indigo-700 border border-indigo-200',
    tile: 'text-indigo-600',
    dot: 'bg-indigo-500',
    explanation: 'Your settlement is currently being processed.',
  },
  paid: {
    key: 'paid',
    label: 'Paid',
    tileLabel: 'Paid Settlements',
    badge: 'bg-green-50 text-green-700 border border-green-200',
    tile: 'text-green-600',
    dot: 'bg-green-500',
    explanation: 'Your settlement was issued.',
  },
  under_review: {
    key: 'under_review',
    label: 'Under Review',
    tileLabel: 'Under Review',
    badge: 'bg-purple-50 text-purple-700 border border-purple-200',
    tile: 'text-purple-600',
    dot: 'bg-purple-500',
    explanation:
      'This settlement is under review following a challenge. We may need up to 5 additional business days to complete the review. Your settlement amount stays visible while we review.',
  },
};

// Ordered lifecycle used by the visual settlement timeline.
export const SETTLEMENT_TIMELINE = [
  { key: 'completed', label: 'Shift Completed' },
  { key: 'pending_approval', label: 'Pending Approval' },
  { key: 'approved', label: 'Approved' },
  { key: 'payment_processing', label: 'Processing' },
  { key: 'paid', label: 'Paid' },
];

export function statusConfig(status) {
  return SETTLEMENT_STATUS[status] || SETTLEMENT_STATUS.pending_approval;
}

// Index of a status within the linear timeline (under_review maps onto its
// pre-challenge position but is rendered as a branch, handled by the UI).
export function timelineIndex(status) {
  const map = {
    pending_approval: 1,
    approved: 2,
    payment_processing: 3,
    paid: 4,
    under_review: 1,
  };
  return map[status] ?? 1;
}
